import axiosInstance from "./axiosInstance";

// 取得會員個人資料
export const getUserProfile = () => axiosInstance.get("/users/profile");

// 更新會員個人資料
export const updateUserProfile = (data) => axiosInstance.put("/users/profile", data);

//更新會員個人密碼
export const updatePassword = async (data) => {
    const res = await axiosInstance.put("/users/change-password", data);
    return res.data; // ✅ 回傳資料內容，而不是整包 axios response
  };

  // ✅ 忘記舊密碼：寄重設信到自己的註冊信箱（登入狀態下使用）
export const requestOwnPasswordReset = async () => {
  const res = await axiosInstance.post("/users/request-password-reset");
  return res.data;
};

  // ✅ 取得 API Key 清單
export const getUserAPIKeys = async () => {
  const res = await axiosInstance.get("/users/api-keys");
  return res.data;
};

// ✅ 新增 API Key
export const createUserAPIKey = async (data) => {
  const res = await axiosInstance.post("/users/api-keys", data);
  return res.data;
};

// ✅ 更新 API Key 名稱或分類
export const updateUserAPIKey = async (id, data) => {
  const res = await axiosInstance.put(`/users/api-keys/${id}`, data);
  return res.data;
};

// ✅ 刪除 API Key
export const deleteUserAPIKey = async (id) => {
  const res = await axiosInstance.delete(`/users/api-keys/${id}`);
  return res.data;
};



// 取得推薦名單
export const getReferralUsers = async () => {
  try {
    const res = await axiosInstance.get("/referrals/list");
    return res.data; // 後端會回傳陣列
  } catch (err) {
    console.error("❌ 無法取得推薦名單：", err);
    return [];
  }
};

// 取得推薦收益紀錄
export const getReferralEarnings = async () => {
  try {
    const res = await axiosInstance.get("/referrals/earnings");
    return res.data; // 後端會回傳陣列
  } catch (err) {
    console.error("❌ 無法取得推薦收益紀錄：", err);
    return [];
  }
};


export async function getReferralEarningsSummary(params = {}) {
  const { data } = await axiosInstance.get("/referrals/earnings/summary", { params });
  return data; // ← 只回傳 data 裡的資料，不包含 ok
}

export async function getReferralEarningsRecords(params = {}) {
  const { data } = await axiosInstance.get("/referrals/earnings/records", { params });
  return data.data; // ← 同上
}

// ===== 推薦收益提領 =====
// 提領資格 / 可提領餘額 / 預填補件資料
export async function getWithdrawalEligibility() {
  const { data } = await axiosInstance.get("/referrals/withdrawals/eligibility");
  return data?.data;
}

// 建立提領申請（錯誤讓它往上拋，由對話框接 err.response.data.code 顯示）
export async function createReferralWithdrawal(payload) {
  const { data } = await axiosInstance.post("/referrals/withdrawals", payload);
  return data?.data;
}

// 我的提領紀錄
export async function getMyReferralWithdrawals(params = {}) {
  const { data } = await axiosInstance.get("/referrals/withdrawals", { params });
  return data?.data;
}

// 取消提領（僅審核中可取消）
export async function cancelReferralWithdrawal(id) {
  const { data } = await axiosInstance.post(`/referrals/withdrawals/${id}/cancel`);
  return data?.data;
}
